// extracted by mini-css-extract-plugin
module.exports = {"input":"DropdownInputFilter_input__3wKla"};